module.exports = __webpack_public_path__ + "static/media/banner_1920x350-1.afbcb7a8.jpg";